module.exports = __webpack_public_path__ + "media/images/icon/danger-f6dc099240cc766d0ba0fcacb7b1a74d.svg";